import type { Zone } from '@seek/audience-zones';

import type { AnalyticsFacade } from 'src/modules/AnalyticsFacade';
import { logger } from 'src/modules/logger';
import type createStore from 'src/store/createStore';
import {
  experimentsAfterAuthIntialised,
  FEATURE_EXPERIMENTS_AFTER_AUTH,
} from 'src/store/experiments';
import { mapToSeekExperiments } from 'src/store/experiments/experimentHelpers';
import { updateFeatureFlagsAfterAuth } from 'src/store/featureFlags';
import type { CookieType } from 'src/types/cookie';

export const initialiseSignedInExperiments = ({
  seekerId,
  zone,
  store,
  cookies,
  analyticsFacade,
}: {
  seekerId: number;
  zone: Zone;
  store: ReturnType<typeof createStore>;
  cookies: CookieType;
  analyticsFacade: AnalyticsFacade;
}) => {
  const { dispatch } = store;
  const seekExperimentsAfterAuth = mapToSeekExperiments({
    userId: String(seekerId),
    featureExperiments: FEATURE_EXPERIMENTS_AFTER_AUTH,
    shouldExcludeFromExperiment: false,
    zone,
  });

  dispatch(experimentsAfterAuthIntialised(seekExperimentsAfterAuth));
  dispatch(updateFeatureFlagsAfterAuth(cookies, seekExperimentsAfterAuth));

  const { experiments: experimentsAfterAuth } = store.getState();

  analyticsFacade.registerExperiments(experimentsAfterAuth);

  logger.setFeatureFlags?.(experimentsAfterAuth);
  logger.setUserId?.(String(seekerId));
};
